import React from 'react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = () => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <div className="fixed top-20 md:top-24 right-2 md:right-6 z-[60] scale-50 sm:scale-75 md:scale-100 origin-top-right">
      {/* Light switch plate */}
      <div 
        className="relative w-20 h-32 rounded-lg shadow-2xl transition-all duration-300"
        style={{
          background: isDark 
            ? 'linear-gradient(135deg, #2d3748 0%, #1a202c 100%)'
            : 'linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%)',
          border: isDark ? '2px solid #4a5568' : '2px solid #cbd5e0',
          boxShadow: isDark 
            ? '0 10px 30px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.1)'
            : '0 10px 30px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.8)'
        }}
      >
        {/* Screw details */}
        <div 
          className="absolute top-2 left-1/2 transform -translate-x-1/2 w-3 h-3 rounded-full"
          style={{
            background: isDark ? '#4a5568' : '#cbd5e0',
            boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.3)'
          }}
        >
          <div className="absolute inset-0 flex items-center justify-center">
            <div 
              className="w-2 h-0.5"
              style={{ background: isDark ? '#2d3748' : '#a0aec0' }}
            />
          </div>
        </div>
        <div 
          className="absolute bottom-2 left-1/2 transform -translate-x-1/2 w-3 h-3 rounded-full"
          style={{
            background: isDark ? '#4a5568' : '#cbd5e0',
            boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.3)'
          }}
        >
          <div className="absolute inset-0 flex items-center justify-center">
            <div 
              className="w-2 h-0.5"
              style={{ background: isDark ? '#2d3748' : '#a0aec0' }}
            />
          </div>
        </div>

        {/* Switch toggle */}
        <button
          onClick={toggleTheme}
          className="absolute left-1/2 transform -translate-x-1/2 w-10 h-16 rounded transition-all duration-300 hover:scale-105 focus:outline-none z-10"
          style={{
            top: isDark ? '52%' : '32%',
            background: isDark
              ? 'linear-gradient(180deg, #4a5568 0%, #2d3748 100%)'
              : 'linear-gradient(180deg, #edf2f7 0%, #e2e8f0 100%)',
            boxShadow: isDark
              ? '0 4px 8px rgba(0, 0, 0, 0.3), inset 0 -2px 4px rgba(0, 0, 0, 0.2)'
              : '0 4px 8px rgba(0, 0, 0, 0.1), inset 0 -2px 4px rgba(0, 0, 0, 0.1)',
            border: isDark ? '1px solid #1a202c' : '1px solid #cbd5e0'
          }}
          aria-label="Toggle theme"
        >
          {/* Switch toggle indicator line */}
          <div 
            className="absolute left-1/2 transform -translate-x-1/2 w-6 h-1 rounded-full"
            style={{
              top: '40%',
              background: isDark ? '#718096' : '#a0aec0'
            }}
          />
        </button>

        {/* Status labels */}
        <div className="absolute left-1/2 transform -translate-x-1/2 top-3 text-xs font-bold pointer-events-none"
          style={{ color: isDark ? '#718096' : '#4a5568' }}
        >
          ON
        </div>
        <div className="absolute left-1/2 transform -translate-x-1/2 bottom-3 text-xs font-bold pointer-events-none"
          style={{ color: isDark ? '#718096' : '#4a5568' }}
        >
          OFF
        </div>
      </div>

      {/* Glow effect when ON (light mode) */}
      {!isDark && (
        <div 
          className="absolute -inset-2 rounded-lg blur-xl opacity-60 animate-pulse"
          style={{
            background: 'radial-gradient(circle, rgba(251, 191, 36, 0.4) 0%, transparent 70%)',
            pointerEvents: 'none'
          }}
        />
      )}
    </div>
  );
};

export default ThemeToggle;
